import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useCartStore } from 'stores';
import { stripLocaleFromPathname } from 'utils/localePath';
//custom hooks
import useAssignedLibrary from 'utils/customHooks/useAssignedLibrary';

const ResetOnRouteChangeCartDiscount = ({ children }) => {
  const location = useLocation();
  const { discountCart, isShippingAvailable, resetDiscountCart, setIsShippingAvailable } = useCartStore();
  const { assignedLibrary } = useAssignedLibrary();

  useEffect(() => {
    const excludedPaths = [`/${assignedLibrary}/carrito`, `/${assignedLibrary}/envio`, `/${assignedLibrary}/pago`];
    const pathWithoutLocale = stripLocaleFromPathname(location.pathname);
    const isExcluded = excludedPaths.includes(pathWithoutLocale);
    if (!isExcluded && discountCart?.has_discount && discountCart.type !== 'gift_card') {
      resetDiscountCart();
    }
    if (!isExcluded && !isShippingAvailable?.availability) {
      setIsShippingAvailable({ availability: true, message: '' });
    }
  }, [location.pathname, discountCart, isShippingAvailable, assignedLibrary, resetDiscountCart, setIsShippingAvailable]);
  return children;
};

export default ResetOnRouteChangeCartDiscount;
